import React, { useEffect } from "react";
import {
  SectionTitle,
  ButtonsContainer,
  Button,
  StyledTitleContainer,
} from "./CouponsPage.styles";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { selectedCouponsDashboard } from "../../../store/slices/coupon/couponSlice";
import { getCouponsDashboard } from "../../../store/slices/coupon/asyncThunks";
import AllCoupons from "../../../components/Coupons/AllCoupons";
import StatusCoupons from "../../../components/Coupons/StatusCoupons";
import { selectBusinessUserInfo } from "../../../store/slices/businessUser/slice";
import { selectedLocale } from "../../../store/slices/common/slice";
import { checkPermission } from "../../../utils/utils";
import { businessUserRoleAction } from "../../../utils/constants";

const CouponsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const businessUser = useSelector(selectBusinessUserInfo);
  const coupons = useSelector(selectedCouponsDashboard);

  useEffect(() => {
    if (checkPermission(businessUser, businessUserRoleAction.get_coupons)) {
      dispatch(getCouponsDashboard())
        .unwrap()
        .catch((err) => toast.error(t(err.message)));
    }
  }, [dispatch]);

  const onClickMoreActive = () => {
    const query = { page: 1, type: "ACTIVE" };
    const queryString = new URLSearchParams(query).toString();
    const url = `/admin-portal/coupons?${queryString}`;

    navigate(url);
  };

  const onClickMoreDeactivated = () => {
    const query = { page: 1, type: "DEACTIVATED" };
    const queryString = new URLSearchParams(query).toString();
    const url = `/admin-portal/coupons?${queryString}`;

    navigate(url);
  };

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  return (
    <>
      <StyledTitleContainer>
        <SectionTitle>{t("coupons")}</SectionTitle>
        {checkPermission(businessUser, businessUserRoleAction.post_coupon) && (
          <ButtonsContainer>
            <Button
              onClick={() => {
                navigate("/admin-portal/coupons/new-coupon");
              }}
            >
              {t("new-coupon")}
            </Button>
          </ButtonsContainer>
        )}
      </StyledTitleContainer>
      {!type && (
        <AllCoupons
          data={coupons}
          onClickMoreActive={onClickMoreActive}
          onClickMoreDeactivated={onClickMoreDeactivated}
          ar={ar}
        />
      )}
      {type === "ACTIVE" && (
        <StatusCoupons
          onBack={() => navigate("/admin-portal/coupons")}
          ar={ar}
        />
      )}
      {type === "DEACTIVATED" && (
        <StatusCoupons
          onBack={() => navigate("/admin-portal/coupons")}
          ar={ar}
        />
      )}
    </>
  );
};

export default CouponsPage;
